export const updateObjByDotNotation = (state, objKey, objNewData) => {
  const str = objKey;

  const currentState = { ...state };
  let pointer = currentState;
  const keys = str.split('.');

  keys.forEach((key, index, arr) => {
    const lastIndex = arr.length - 1;
    const value = index === lastIndex ? objNewData : { ...pointer[key] };
    pointer = pointer[key] = value;
  });

  return currentState;
};
